import React, { useState, useEffect } from "react";
import "./dashboard.scss";
import Header from "../landing/navbar/Header";
import { Dropdown, Modal, ProgressBar, Toast, ToastContainer } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import Footerline from "../landing/footer/Footerline";
import { Calendar } from "react-multi-date-picker";
import AddLeaderModal from "../landing/navbar/AddLeaderModal";
import { Api_Url } from "../../utils/ApiUrl";
import axios from "axios";
import moment from "moment";
import { DateRange } from "react-date-range";
import { toast } from "react-toastify";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useWeb3React } from "@web3-react/core";
import GetGemsBalance from "../../hooks/dataFetchers/getGemsBalance";
import GetGemsStaked from "../../hooks/dataFetchers/getGemsStakedAmount";
import Environment from "../../utils/Environment";
import ProjectCard from "./ProjectCard";
import Loader from "../../hooks/loader";
import { projectConfigurations, tokens } from "../../utils/Constants";

const Dashboard = ({
  tomiPrice,
  usdPrice,
  btcPrice,
  pepePrice,
  linkPrice,
  uniPrice,
  dopPrice,
  gemsPrice,
}) => {
  const val = localStorage.getItem("accessToken");

  const { account } = useWeb3React();
  const { getGemsStaked } = GetGemsStaked();
  const { GetGemsBal } = GetGemsBalance();
  const [stakeEndTime, setStakeEndTime] = useState([]);
  const [stakingData, setStakingData] = useState([]);
  const [loader, setLoader] = useState(false)
  const [subscriptionEndTime, setSubscriptionEndTime] = useState([]);
  const [subscriptionData, setSubscriptionData] = useState([]);
  const [addLeaderBool, setAddLeadBool] = useState(false);

  const [addLeaderModal, setAddLeaderModal] = useState(false);

  const [stakedAmount, setStakedAmount] = useState(0);
  const [balance, setBalance] = useState(0);
  const [reputationPoints, setReputaitonPoints] = useState(0);

  const tok = localStorage.getItem("accessToken");
  const history = useHistory();
  const user = JSON.parse(localStorage?.getItem("user"));
  const [showcalendar, setShowCalendar] = useState(false);
  const [alllset, setalllset] = useState("all");
  const [otherLeaders, setOtherLeaders] = useState([]);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [userselectdate, setuserselectdate] = useState(false);
  const [pc, setPC] = useState(0);
  const [pmc, setPMC] = useState(0);
  const [nrc, setNRC] = useState(0);
  const [lc, setLC] = useState(0);
  const [dpc, setDPC] = useState(0);
  const [lec, setLEC] = useState(0);
  const [a, seta] = useState(0);
  const [m, setm] = useState(0);
  const [s, sets] = useState(0);
  const [g, setg] = useState(0);
  const [gmini, setgmini] = useState(0);

  const [mm, setmm] = useState(0);
  const [ss, setss] = useState(0);
  const [gg, setgg] = useState(0);
  const [ggmini, setggmini] = useState(0);

  const [purchasesAndEarnings, setPurchasedAndEarnings] = useState([]);

  const [pee, setPEE] = useState(0);
  const [peu, setPEU] = useState(0);
  const [pet, setPET] = useState(0);

  const [totPurchases, setTotPurchases] = useState(0);
  const [dopPurchased, setDOPPurchased] = useState(0);

  const [ind, setIND] = useState(0);
  const [dt, setDT] = useState(0);
  const [totalleader, settotalleader] = useState(0);
  const [dataTime, setDataTime] = useState("1");
  const [state, setState] = useState([
    {
      startDate: new Date(),
      endDate: null,
      key: "selection",
    },
  ]);
  const [adminobj, setadminobj] = useState();
  const [tokenNftStats, setTokenNftStats] = useState();


  const [showcredits, setShowcredits] = useState(false);
  const handleClosecredits = () => setShowcredits(false);
  const handleShowcredits = () => setShowcredits(true);

  const [activeleader, setactiveleader] = useState(0);

  const [specialAccess, setSpecialAccess] = useState([]);
  const [myTree, setMyTree] = useState([]);

  const [showqr, setShowQr] = useState(false);




  const ReputationPoints = async () => {
    var config = {
      method: "get",
      url: `${Api_Url}/users/reputation-points`,
      headers: {
        Authorization: "Bearer " + val,
      },
    };
    axios(config)
      .then(function (response) {
        setReputaitonPoints(response?.data?.data?.reputationPoints);
      })
      .catch(function (error) { });
  };

  const imgSource = {
    emerald: "/assets/premium/emerald.svg",
    sapphire: "/assets/premium/sapphire.svg",
    ruby: "/assets/premium/ruby.svg",
    diamond: "/assets/premium/diamond.svg",
    reddiamond: "/assets/premium/reddiamond.svg",
  };
  const getCreditPack = () => {
    const value = stakedAmount + balance;
    if (30000 <= value && value < 75000) {
      return "emerald";
    } else if (75000 <= value && value < 150000) {
      return "sapphire";
    } else if (150000 <= value && value < 450000) {
      return "ruby";
    } else if (450000 <= value && value < 1500000) {
      return "diamond";
    } else if (1500000 <= value) {
      return "reddiamond";
    } else {
      return "noPack";
    }
  };
  const fetchSubscriptionData = async (useV2 = false) => {
    const graphURL = useV2
      ? Environment.GEMSSubscriptionGraph_v2
      : Environment.GEMSSubscriptionGraph;

    const data = JSON.stringify({
      query: `query MyQuery {
      subscribeds(where: {by: "${user?.walletAddress}"}, orderBy: blockTimestamp, orderDirection: desc) {
        blockTimestamp
        blockNumber
        amountPurchased
        by
        endTime
        id
        tokenPrice
        transactionHash
      }
    }`,
      variables: {},
    });

    const config = {
      method: "post",
      url: graphURL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    await axios(config)
      .then(async function (response) {
        const resData = response?.data?.data?.subscribeds;
        // If no data and not already using v2, retry with v2
        if ((!resData || resData.length === 0) && !useV2) {
          return fetchSubscriptionData(true);
        }
        if (resData?.length > 0) {
          setSubscriptionData(resData);
          console.log("res data: ", resData);

          const currentTime = moment();
          const endTimeStampInSeconds = parseInt(resData[0]?.endTime);
          const endTimeStamp = moment(endTimeStampInSeconds * 1000);

          if (!endTimeStampInSeconds || currentTime.isAfter(endTimeStamp)) {
            if (!useV2) {
              // Retry using GEMSSubscriptionGraph_v2 if not already done
              return fetchSubscriptionData(true);
            } else {
              setSubscriptionEndTime(currentTime); // fallback
            }
          } else {
            setSubscriptionEndTime(endTimeStamp);
          }
        }
      })
      .catch(function (error) {
        console.log(error, "error");
      });
  };

  //   const fetchSubscriptionData = async () => {
  //     var data = JSON.stringify({
  //       query: `query MyQuery {
  //   subscribeds(where: {by: "${user?.walletAddress}"}, orderBy: blockTimestamp, orderDirection: desc) {
  //     blockTimestamp
  //     blockNumber
  //     amountPurchased
  //     by
  //     endTime
  //     id
  //     tokenPrice
  //     transactionHash
  //   }
  // }`,
  //       variables: {},
  //     });
  //     var config = {
  //       method: "post",
  //       url: Environment.GEMSSubscriptionGraph,
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       data: data,
  //     };
  //     await axios(config)
  //       .then(async function (response) {
  //         const resData = response.data.data.subscribeds;
  //         if (resData.length > 0) {
  //           // setStakeIndux1(parseInt(resData[0]?.stakerStakeIndex));
  //           setSubscriptionData(resData);
  //           console.log("res data: ", resData);

  //           const currentTime = moment();
  //           const endTimeStampInSeconds = parseInt(resData[0]?.endTime);
  //           const endTimeStamp = moment(endTimeStampInSeconds * 1000);

  //           if (!endTimeStamp) {
  //             setSubscriptionEndTime(currentTime);
  //           } else {
  //             setSubscriptionEndTime(endTimeStamp);
  //           }
  //         }
  //       })
  //       .catch(function (error) {
  //         console.log(error, "error");
  //       });
  //   };

  const fetchStakingData = async () => {
    try {
      const response = await axios.post(
        Environment?.GEMSStakingGraph,
        {
          query: `
            query MyQuery($staker: String, $isClaimed: Boolean,) {
              stakeds(where: {staker: $staker}, isClaimed: $isClaimed,) {
              
                blockTimestamp
                stakeEndTime
                isClaimed
              }
            }`,
          variables: {
            staker: user?.walletAddress,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const resData = response.data.data.stakeds;
      setStakingData(resData);
      const currentTime = moment();
      const endTimeStampInSeconds = parseInt(
        resData[resData?.length - 1]?.stakeEndTime
      );
      const endTimeStamp = moment(endTimeStampInSeconds * 1000); // Convert to milliseconds
      if (!endTimeStamp.isValid()) {
        setStakeEndTime(currentTime);
      } else {
        setStakeEndTime(endTimeStamp);
      }
    } catch (error) {
      console.error("Error fetching staking data: ", error);
    }
  };

  useEffect(() => {
    if (account) {
      getGemsBalanceFunc();
    }
  }, [account]);

  useEffect(() => {
    if (user) {
      fetchSubscriptionData();
      fetchStakingData();
      getGemsStakedAmount();
    }
  }, []);

  const getGemsStakedAmount = async () => {
    const staked = await getGemsStaked(user?.walletAddress);
    if (staked) {
      setStakedAmount(staked);
    }
  };
  const getGemsBalanceFunc = async () => {
    const bal = await GetGemsBal(account);
    if (bal !== null || bal !== undefined) {
      setBalance(bal);
    }
  };

  useEffect(() => {
    if (tok && tok !== "" && tok !== undefined) {
      if (usdPrice) {
        if (user?.role == "mini_agent") {
          // setwelcome("Ambassador");
          // GetDashboardDataMyUsers1("all");
          GetMyData();
        } else if (user?.role == "agent") {
          // setwelcome("Leader");
          // GetDashboardDataMyUsers1("all");
          GetMyData();
        } else if (user?.role == "god_agent") {
          // setwelcome("God Leader");
          // GetDashboardDataMyUsers1("all");
          GetMyData();
        } else if (user?.role == "mega_agent") {
          // setwelcome("Mega Leader");
          // GetDashboardDataMyUsers1("all");
          GetMyData();
        } else if (user?.role == "super_agent") {
          // setwelcome("Super Leader");
          // GetDashboardDataMyUsers1("all");
          GetMyData();
        }
      }
    } else {
      history.push("/login");
    }
  }, [dataTime, usdPrice]);

  useEffect(() => {
    if (tok && tok !== "" && tok !== undefined) {
      ReputationPoints();
      // getClaimStats2();
      // getClaimStats3();
      // getClaimStats4();
      // getClaimStatsLEIA();
      // getClaimStatsOlympus();
      // GetProjectCardDataLeader();
      // GetProjectCardDataAdmin();
      // GetProjectCardDataINCENTIV();
      // GetProjectCardDataLEIA();
      // GetProjectCardDataOlympus();
      // GetProjectCardDataNFA();
      // GetProjectCardDataAstroNova();
      // GetProjectCardDataRain();
      // GetProjectCardDataMatchain();
      // GetProjectCardDataMiners();
      // GetProjectCardDataLuckify()
      //  GetProjectCardDataScrex()
      //  GetProjectCardDataChainers()
    } else {
      history.push("/login");
    }
  }, []);




  // User gode mega leader super data upper stats
  const GetDashboardDataMyUsers = (times) => {
    setalllset();
    setuserselectdate(true);
    setState(times);
    // let date = null;
    // let date1 = null;
    const currentDate = moment();
    const startDate = moment(times[0]?.startDate, "Y-MM-DDT00:00:00");
    const endDate = moment(times[0]?.endDate, "Y-MM-DDT23:59:59");
    if (times) {
      // let a = new Date(times[0]?.startDate);
      // let b = new Date(times[0]?.endDate);
      // date = moment(a).format("Y-MM-DDT00:00:00");
      // date1 = moment(b).format("Y-MM-DDT23:59:59");
    }

    if (
      startDate &&
      endDate &&
      startDate.isBefore(currentDate) &&
      endDate.isBefore(currentDate)
    ) {
      var config = {
        method: "get",
        url: `${Api_Url}/users/dashboard/my/stats?startDate=${startDate.toISOString()}&&endDate=${endDate.toISOString()}`,
        headers: {
          authorization: `Bearer ` + tok,
        },
      };
      axios(config)
        .then(function (response) {
          let value = response?.data?.data;
          // console.log("sdfsfsdfsdfsdfdsfsdfdf", value);
          setTokenNftStats(value);

          setTotPurchases(value?.totalPurchases);
          setDOPPurchased(value?.totalDopPurchased);

          setPurchasedAndEarnings(value?.purchasedAndEarnings);

          let purchasesOld =
            value?.oldPurchasesAndDopPurchased[0]?.TotalPurchases;
          let purchasesNew = value?.totalPurchases;

          let purchaseChange =
            ((purchasesNew - purchasesOld) / purchasesOld) * 100;
          setPC(purchaseChange);

          let oldPurchasedEth =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "ETH"
              ? value?.oldPurchasedAndEarnings[0]?.totalPurchase
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "ETH"
                ? value?.oldPurchasedAndEarnings[1]?.totalPurchase
                : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "ETH"
                  ? value?.oldPurchasedAndEarnings[2]?.totalPurchase
                  : 0;
          let oldPurchasedUsdt =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "USDT"
              ? value?.oldPurchasedAndEarnings[0]?.totalPurchase
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "USDT"
                ? value?.oldPurchasedAndEarnings[1]?.totalPurchase
                : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "USDT"
                  ? value?.oldPurchasedAndEarnings[2]?.totalPurchase
                  : 0;
          let oldPurchasedTomi =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "TOMI"
              ? value?.oldPurchasedAndEarnings[0]?.totalPurchase
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "TOMI"
                ? value?.oldPurchasedAndEarnings[1]?.totalPurchase
                : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "TOMI"
                  ? value?.oldPurchasedAndEarnings[2]?.totalPurchase
                  : 0;

          let newPurchasedEth =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "ETH"
              ? value?.purchasedAndEarnings[0]?.totalPurchase
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "ETH"
                ? value?.purchasedAndEarnings[1]?.totalPurchase
                : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "EETH"
                  ? value?.purchasedAndEarnings[2]?.totalPurchase
                  : 0;
          let newPurchasedUsdt =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "USDT"
              ? value?.purchasedAndEarnings[0]?.totalPurchase
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "USDT"
                ? value?.purchasedAndEarnings[1]?.totalPurchase
                : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "USDT"
                  ? value?.purchasedAndEarnings[2]?.totalPurchase
                  : 0;
          let newPurchasedTomi =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "TOMI"
              ? value?.purchasedAndEarnings[0]?.totalPurchase
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "TOMI"
                ? value?.purchasedAndEarnings[1]?.totalPurchase
                : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "TOMI"
                  ? value?.purchasedAndEarnings[2]?.totalPurchase
                  : 0;

          let newPurchasedAmount =
            newPurchasedEth * usdPrice +
            newPurchasedUsdt +
            newPurchasedTomi * tomiPrice;
          let oldPurchasedAmount =
            oldPurchasedEth * usdPrice +
            oldPurchasedUsdt +
            oldPurchasedTomi * tomiPrice;

          let purchasedAmountChange = 0;

          if (newPurchasedAmount === 0 && oldPurchasedAmount === 0) {
            purchasedAmountChange = 0;
          } else if (newPurchasedAmount === 0 || oldPurchasedAmount === 0) {
            if (newPurchasedAmount === 0) {
              purchasedAmountChange =
                ((0 - oldPurchasedAmount) / oldPurchasedAmount) * 100;
            }
            if (oldPurchasedAmount === 0) {
              purchasedAmountChange = ((newPurchasedAmount + 1 - 1) / 1) * 100;
            }
          } else {
            purchasedAmountChange =
              ((newPurchasedAmount - oldPurchasedAmount) / oldPurchasedAmount) *
              100;
          }

          setPMC(purchasedAmountChange);

          let newLeadersCount =
            value?.agents +
            value?.godAgents +
            value?.megaAgents +
            value?.superAgents +
            value?.miniAgents;
          let oldLeadersCount =
            value?.oldleaders +
            value?.oldgodLeaders +
            value?.oldmegaLeaders +
            value?.oldsuperLeaders +
            value?.oldminiLeaders;
          let leadersChange = 0;
          if (newLeadersCount === 0 && oldLeadersCount === 0) {
            leadersChange = 0;
          } else if (newLeadersCount === 0 || oldLeadersCount === 0) {
            if (newLeadersCount === 0) {
              leadersChange = ((0 - oldLeadersCount) / oldLeadersCount) * 100;
            }
            if (oldLeadersCount === 0) {
              leadersChange = ((newLeadersCount + 1 - 1) / 1) * 100;
            }
          } else {
            leadersChange =
              ((newLeadersCount - oldLeadersCount) / oldLeadersCount) * 100;
          }

          setLC(leadersChange);
          let dopChange =
            ((value?.totalDopPurchased -
              value?.oldPurchasesAndDopPurchased[0]?.totalDopPurchased) /
              value?.oldPurchasesAndDopPurchased[0]?.totalDopPurchased) *
            100;

          setDPC(dopChange);

          let oldEarningsEth =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "ETH"
              ? value?.oldPurchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "ETH"
                ? value?.oldPurchasedAndEarnings[1]?.totalLeaderEarnings
                : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "ETH"
                  ? value?.oldPurchasedAndEarnings[2]?.totalLeaderEarnings
                  : 0;
          let oldEarningsUsdt =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "USDT"
              ? value?.oldPurchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "USDT"
                ? value?.oldPurchasedAndEarnings[1]?.totalLeaderEarnings
                : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "USDT"
                  ? value?.oldPurchasedAndEarnings[2]?.totalLeaderEarnings
                  : 0;
          let oldEarningsTomi =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "TOMI"
              ? value?.oldPurchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "TOMI"
                ? value?.oldPurchasedAndEarnings[1]?.totalLeaderEarnings
                : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "TOMI"
                  ? value?.oldPurchasedAndEarnings[2]?.totalLeaderEarnings
                  : 0;

          let newEarningsEth =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "ETH"
              ? value?.purchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "ETH"
                ? value?.purchasedAndEarnings[1]?.totalLeaderEarnings
                : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "EETH"
                  ? value?.purchasedAndEarnings[2]?.totalLeaderEarnings
                  : 0;
          let newEarningsUsdt =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "USDT"
              ? value?.purchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "USDT"
                ? value?.purchasedAndEarnings[1]?.totalLeaderEarnings
                : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "USDT"
                  ? value?.purchasedAndEarnings[2]?.totalLeaderEarnings
                  : 0;
          let newEarningsTomi =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "TOMI"
              ? value?.purchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "TOMI"
                ? value?.purchasedAndEarnings[1]?.totalLeaderEarnings
                : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "TOMI"
                  ? value?.purchasedAndEarnings[2]?.totalLeaderEarnings
                  : 0;

          let earningsChange =
            ((newEarningsEth * usdPrice +
              newEarningsUsdt +
              newEarningsTomi * tomiPrice -
              (oldEarningsEth * usdPrice +
                oldEarningsUsdt +
                oldEarningsTomi * tomiPrice)) /
              (oldEarningsEth * usdPrice +
                oldEarningsUsdt +
                oldEarningsTomi * tomiPrice)) *
            100;

          let totalLeaderEarningsOldPrice =
            oldEarningsEth * usdPrice +
            oldEarningsUsdt +
            oldEarningsTomi * tomiPrice;
          let totalLeaderEarningsNewPrice =
            newEarningsEth * usdPrice +
            newEarningsUsdt +
            newEarningsTomi * tomiPrice;

          let totalLeadersEarningChange = 0;

          if (
            totalLeaderEarningsNewPrice === 0 &&
            totalLeaderEarningsOldPrice === 0
          ) {
            totalLeadersEarningChange = 0;
          } else if (
            totalLeaderEarningsNewPrice === 0 ||
            totalLeaderEarningsOldPrice === 0
          ) {
            if (totalLeaderEarningsNewPrice === 0) {
              totalLeadersEarningChange =
                ((0 - totalLeaderEarningsOldPrice) /
                  totalLeaderEarningsOldPrice) *
                100;
            }
            if (totalLeaderEarningsOldPrice === 0) {
              totalLeadersEarningChange =
                ((totalLeaderEarningsNewPrice + 1 - 1) / 1) * 100;
            }
          } else {
            totalLeadersEarningChange =
              ((totalLeaderEarningsNewPrice - totalLeaderEarningsOldPrice) /
                totalLeaderEarningsOldPrice) *
              100;
          }

          setLEC(totalLeadersEarningChange);
          setgg(value?.leaders);
          setggmini(value?.miniLeaders);
          setactiveleader(value?.activeLeaders);

          setmm(value?.megas);
          setss(value?.supers);

          // setTimeout(() => {
          //   setShowCalendar(false)
          // }, 3000);
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      toast.error("Date must be today or earlier.");
    }
  };

  const GetDashboardDataMyUsers1 = (alll) => {
    setuserselectdate(true);
    let date = null;
    let date1 = null;
    if (alll == "1") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 0; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (alll == "seven") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 7; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (alll == "year") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 365; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (alll == "month") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 31; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    }
    if (date && date1) {
      const apiUrl = `${Api_Url}/users/dashboard/my/stats?startDate=${date}&&endDate=${date1}`;

      var config = {
        method: "get",
        url: apiUrl,
        headers: {
          authorization: `Bearer ` + tok,
        },
      };
      axios(config)
        .then(function (response) {
          // console.log("responce",response)
          let value = response?.data?.data;
          // console.log("sdfsfsdfsdfsdfdsfsdfdf", value)
          setTokenNftStats(value);

          setTotPurchases(value?.totalPurchases);
          setDOPPurchased(value?.totalDopPurchased);
          setPurchasedAndEarnings(value?.purchasedAndEarnings);

          let purchasesOld =
            value?.oldPurchasesAndDopPurchased[0]?.TotalPurchases;
          let purchasesNew = value?.totalPurchases;

          let purchaseChange =
            ((purchasesNew - purchasesOld) / purchasesOld) * 100;
          setPC(purchaseChange);

          let oldPurchasedEth =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "ETH"
              ? value?.oldPurchasedAndEarnings[0]?.totalPurchase
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "ETH"
                ? value?.oldPurchasedAndEarnings[1]?.totalPurchase
                : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "ETH"
                  ? value?.oldPurchasedAndEarnings[2]?.totalPurchase
                  : 0;
          let oldPurchasedUsdt =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "USDT"
              ? value?.oldPurchasedAndEarnings[0]?.totalPurchase
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "USDT"
                ? value?.oldPurchasedAndEarnings[1]?.totalPurchase
                : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "USDT"
                  ? value?.oldPurchasedAndEarnings[2]?.totalPurchase
                  : 0;
          let oldPurchasedTomi =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "TOMI"
              ? value?.oldPurchasedAndEarnings[0]?.totalPurchase
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "TOMI"
                ? value?.oldPurchasedAndEarnings[1]?.totalPurchase
                : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "TOMI"
                  ? value?.oldPurchasedAndEarnings[2]?.totalPurchase
                  : 0;

          let newPurchasedEth =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "ETH"
              ? value?.purchasedAndEarnings[0]?.totalPurchase
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "ETH"
                ? value?.purchasedAndEarnings[1]?.totalPurchase
                : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "EETH"
                  ? value?.purchasedAndEarnings[2]?.totalPurchase
                  : 0;
          let newPurchasedUsdt =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "USDT"
              ? value?.purchasedAndEarnings[0]?.totalPurchase
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "USDT"
                ? value?.purchasedAndEarnings[1]?.totalPurchase
                : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "USDT"
                  ? value?.purchasedAndEarnings[2]?.totalPurchase
                  : 0;
          let newPurchasedTomi =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "TOMI"
              ? value?.purchasedAndEarnings[0]?.totalPurchase
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "TOMI"
                ? value?.purchasedAndEarnings[1]?.totalPurchase
                : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "TOMI"
                  ? value?.purchasedAndEarnings[2]?.totalPurchase
                  : 0;

          let newPurchasedAmount =
            newPurchasedEth * usdPrice +
            newPurchasedUsdt +
            newPurchasedTomi * tomiPrice;
          let oldPurchasedAmount =
            oldPurchasedEth * usdPrice +
            oldPurchasedUsdt +
            oldPurchasedTomi * tomiPrice;

          let purchasedAmountChange = 0;

          if (newPurchasedAmount === 0 && oldPurchasedAmount === 0) {
            purchasedAmountChange = 0;
          } else if (newPurchasedAmount === 0 || oldPurchasedAmount === 0) {
            if (newPurchasedAmount === 0) {
              purchasedAmountChange =
                ((0 - oldPurchasedAmount) / oldPurchasedAmount) * 100;
            }
            if (oldPurchasedAmount === 0) {
              purchasedAmountChange = ((newPurchasedAmount + 1 - 1) / 1) * 100;
            }
          } else {
            purchasedAmountChange =
              ((newPurchasedAmount - oldPurchasedAmount) / oldPurchasedAmount) *
              100;
          }

          setPMC(purchasedAmountChange);
          let newLeadersCount =
            value?.agents +
            value?.godAgents +
            value?.megaAgents +
            value?.superAgents +
            value?.miniAgents;
          let oldLeadersCount =
            value?.oldleaders +
            value?.oldgodLeaders +
            value?.oldmegaLeaders +
            value?.oldsuperLeaders +
            value?.oldminiLeaders;
          let leadersChange = 0;
          if (newLeadersCount === 0 && oldLeadersCount === 0) {
            leadersChange = 0;
          } else if (newLeadersCount === 0 || oldLeadersCount === 0) {
            if (newLeadersCount === 0) {
              leadersChange = ((0 - oldLeadersCount) / oldLeadersCount) * 100;
            }
            if (oldLeadersCount === 0) {
              leadersChange = ((newLeadersCount + 1 - 1) / 1) * 100;
            }
          } else {
            leadersChange =
              ((newLeadersCount - oldLeadersCount) / oldLeadersCount) * 100;
          }

          setLC(leadersChange);
          let oldDOPChange =
            value?.oldPurchasesAndDopPurchased[0]?.totalDopPurchased;
          let dopChange =
            ((value?.totalDopPurchased - oldDOPChange) / oldDOPChange) * 100;

          setDPC(dopChange);

          let oldEarningsEth =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "ETH"
              ? value?.oldPurchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "ETH"
                ? value?.oldPurchasedAndEarnings[1]?.totalLeaderEarnings
                : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "ETH"
                  ? value?.oldPurchasedAndEarnings[2]?.totalLeaderEarnings
                  : 0;
          let oldEarningsUsdt =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "USDT"
              ? value?.oldPurchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "USDT"
                ? value?.oldPurchasedAndEarnings[1]?.totalLeaderEarnings
                : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "USDT"
                  ? value?.oldPurchasedAndEarnings[2]?.totalLeaderEarnings
                  : 0;
          let oldEarningsTomi =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "TOMI"
              ? value?.oldPurchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "TOMI"
                ? value?.oldPurchasedAndEarnings[1]?.totalLeaderEarnings
                : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "TOMI"
                  ? value?.oldPurchasedAndEarnings[2]?.totalLeaderEarnings
                  : 0;

          let newEarningsEth =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "ETH"
              ? value?.purchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "ETH"
                ? value?.purchasedAndEarnings[1]?.totalLeaderEarnings
                : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "EETH"
                  ? value?.purchasedAndEarnings[2]?.totalLeaderEarnings
                  : 0;
          let newEarningsUsdt =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "USDT"
              ? value?.purchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "USDT"
                ? value?.purchasedAndEarnings[1]?.totalLeaderEarnings
                : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "USDT"
                  ? value?.purchasedAndEarnings[2]?.totalLeaderEarnings
                  : 0;
          let newEarningsTomi =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "TOMI"
              ? value?.purchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "TOMI"
                ? value?.purchasedAndEarnings[1]?.totalLeaderEarnings
                : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "TOMI"
                  ? value?.purchasedAndEarnings[2]?.totalLeaderEarnings
                  : 0;

          let totalLeaderEarningsOldPrice =
            oldEarningsEth * usdPrice +
            oldEarningsUsdt +
            oldEarningsTomi * tomiPrice;
          let totalLeaderEarningsNewPrice =
            newEarningsEth * usdPrice +
            newEarningsUsdt +
            newEarningsTomi * tomiPrice;

          let totalLeadersEarningChange = 0;

          if (
            totalLeaderEarningsNewPrice === 0 &&
            totalLeaderEarningsOldPrice === 0
          ) {
            totalLeadersEarningChange = 0;
          } else if (
            totalLeaderEarningsNewPrice === 0 ||
            totalLeaderEarningsOldPrice === 0
          ) {
            if (totalLeaderEarningsNewPrice === 0) {
              totalLeadersEarningChange =
                ((0 - totalLeaderEarningsOldPrice) /
                  totalLeaderEarningsOldPrice) *
                100;
            }
            if (totalLeaderEarningsOldPrice === 0) {
              totalLeadersEarningChange =
                ((totalLeaderEarningsNewPrice + 1 - 1) / 1) * 100;
            }
          } else {
            totalLeadersEarningChange =
              ((totalLeaderEarningsNewPrice - totalLeaderEarningsOldPrice) /
                totalLeaderEarningsOldPrice) *
              100;
          }

          setLEC(totalLeadersEarningChange);
          setgg(value?.leaders);
          setggmini(value?.miniLeaders);
          setactiveleader(value?.activeLeaders);

          setmm(value?.megas);
          setss(value?.supers);
          // if (response?.data?.data?.stats?.length > 0) {
          //   // setadminobj(response?.data?.data?.stats[0]);
          // }
          // let value = response?.data?.data;
          // setPC(value?.purchasesChange)
          // setPMC(value?.purchasesAmountChange)
          // setNRC(value?.netRevenueChange)
          // setLC(value?.leadersChange)
          // setDPC(value?.dopPurchasedChange)
          // setLEC(value?.leaderEarningsChange)

          // seta(value?.agents);
          // setg(value?.godAgents);
          // setm(value?.megaAgents);
          // sets(value?.superAgents);
          // settotalleader(
          //   value?.agents +
          //   value?.godAgents +
          //   value?.megaAgents +
          //   value?.superAgents
          // );
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  const GetMyData = async () => {
    const apiUrl = `${Api_Url}/users/dashboard/my/stats`;
    const tok = localStorage?.getItem("accessToken");
    // if (account) {
    var config = {
      method: "get",
      url: apiUrl,
      headers: {
        authorization: `Bearer ` + tok,
      },
    };
    axios(config)
      .then(function (response) {
        setuserselectdate(false);
        let value = response?.data?.data;
        setTokenNftStats(value);

        // console.log("sdfsfsdfsdfsdfdsfsdfdf", value);

        setTotPurchases(value?.totalPurchases);
        setDOPPurchased(value?.totalDopPurchased);
        setPurchasedAndEarnings(value?.purchasedAndEarnings);

        // let purchasesOld =
        //   value?.oldPurchasesAndDopPurchased[0]?.TotalPurchases;
        // let purchasesNew = value?.totalPurchases;

        // let purchaseChange =
        //   ((purchasesNew - purchasesOld) / purchasesOld) * 100;
        setPC(0);

        setPMC(0);

        setLC(0);

        setDPC(0);

        setLEC(0);
        setgg(value?.leaders);
        setggmini(value?.miniLeaders);
        setactiveleader(value?.activeLeaders);

        setmm(value?.megas);
        setss(value?.supers);
      })
      .catch(function (error) {
        // console.log("status: ", error?.response);
        if (error?.response?.status == 401) {
          // history.push("/login");
        }

        console.log(error);
      });
    // }
  };











  // ============= UNIFIED STATE MANAGEMENT =============

  // Single state for all project stats
  const [projectStats, setProjectStats] = useState({});

  // Single state for all claim stats
  const [claimStats, setClaimStats] = useState({
    GEMS: { claimableCount: 0, totalClaimed: 0 },
    DOP: { claimableCount: 0, totalClaimed: 0 },
    INCENTIV: { claimableCount: 0, totalClaimed: 0 },
    LEIA: { claimableCount: 0, totalClaimed: 0 },
    OLYMPUS: { claimableCount: 0, totalClaimed: 0 },
    NFA: { claimableCount: 0, totalClaimed: 0 },
  });

  // Backward compatibility - derived states
  const projectCardData = projectStats.GEMS;
  const projectCardStats = projectStats.DOP;
  const projectCardStatsINCENTIV = projectStats.INCENTIV;
  const projectCardStatsLEIA = projectStats.LEIA;
  const projectCardStatsOLYMPUS = projectStats.OLYMPUS;
  const projectCardStatsNFA = projectStats.NFA;
  const projectCardStatsAstroNova = projectStats.ASTRANOVA;
  const projectCardStatsRain = projectStats.RAIN;
  const projectCardStatsMatchain = projectStats.MATCHAIN;
  const projectCardStatsLuckify = projectStats.LUCKIFY;
  const projectCardStatsScrex = projectStats.SCREX;
  const projectCardStatsChainers = projectStats.CHAINERS;
  const projectCardStatsMiners = projectStats.NODEMINER;

  const claimStats2 = claimStats.GEMS;
  const claimStats3 = claimStats.DOP;
  const claimStats4 = claimStats.INCENTIV;
  const claimStatsLEIA = claimStats.LEIA;
  const claimStatsOLYMPUS = claimStats.OLYMPUS;
  const claimStatsNFA = claimStats.NFA;

  // ============= CONFIGURATIONS =============



  const claimStatsConfigurations = [
    { id: "PRC", privateSale: "PRC " },
    // { id: "DOP", privateSale: "DOP" },
    // { id: "INCENTIV", privateSale: "INCENTIV" },
    // { id: "LEIA", privateSale: "LEIA" },
    // { id: "OLYMPUS", privateSale: "OLYMPUS" },
    // { id: "NFA", privateSale: "NFA" },
  ];

  // ============= GENERIC FETCH FUNCTIONS =============

  // Generic function to fetch project card data
  const fetchProjectCardData = async (privateSale, projectId) => {
    const apiUrl = `${Api_Url}/users/my/stats?privateSale=${privateSale}`;

    const config = {
      method: "get",
      url: apiUrl,
      headers: {
        authorization: `Bearer ` + tok,
      },
    };

    try {
      const response = await axios(config);
      const value = response?.data?.data;

      setProjectStats(prevStats => ({
        ...prevStats,
        [projectId]: value
      }));
    } catch (error) {
      console.log(`Error fetching project data for ${projectId}:`, error);
    }
  };

  // Generic function to fetch claim stats
  const fetchClaimStats = async (privateSale, projectId) => {
    const config = {
      method: "get",
      url: `${Api_Url}/users/leaders-claimed-rebuy?privateSale=${privateSale}`,
      headers: {
        Authorization: "Bearer " + tok,
      },
    };

    try {
      const res = await axios(config);
      setClaimStats(prevStats => ({
        ...prevStats,
        [projectId]: res?.data?.data || { claimableCount: 0, totalClaimed: 0 }
      }));

      // Special handling for GEMS loader
      if (projectId === "GEMS") {
        setLoader(false);
      }
    } catch (error) {
      console.log(`Error fetching claim stats for ${projectId}:`, error);

      if (projectId === "GEMS") {
        setLoader(false);
      }
    }
  };

  // ============= BACKWARD COMPATIBLE FUNCTIONS =============
  // Keep these if other parts of code call them directly

  // const GetProjectCardDataAdmin = () => fetchProjectCardData("GEMS", "GEMS");
  // const GetProjectCardDataLeader = () => fetchProjectCardData("DOP", "DOP");
  // const GetProjectCardDataINCENTIV = () => fetchProjectCardData("INCENTIV", "INCENTIV");
  // const GetProjectCardDataLEIA = () => fetchProjectCardData("LEIA", "LEIA");
  // const GetProjectCardDataOlympus = () => fetchProjectCardData("OLYMPUS", "OLYMPUS");
  // const GetProjectCardDataNFA = () => fetchProjectCardData("NFA", "NFA");
  // const GetProjectCardDataAstroNova = () => fetchProjectCardData("ASTRANOVA", "ASTRANOVA");
  // const GetProjectCardDataRain = () => fetchProjectCardData("RAIN", "RAIN");
  // const GetProjectCardDataMatchain = () => fetchProjectCardData("MATCHAIN", "MATCHAIN");
  // const GetProjectCardDataLuckify = () => fetchProjectCardData("LUCKIFY", "LUCKIFY");
  // const GetProjectCardDataScrex = () => fetchProjectCardData("SCREX", "SCREX");
  // const GetProjectCardDataChainers = () => fetchProjectCardData("CHAINERS", "CHAINERS");
  // const GetProjectCardDataMiners = () => fetchProjectCardData("NODEMINER", "NODEMINER");

  // const getClaimStats2 = () => fetchClaimStats("GEMS", "GEMS");
  // const getClaimStats3 = () => fetchClaimStats("DOP", "DOP");
  // const getClaimStats4 = () => fetchClaimStats("INCENTIV", "INCENTIV");
  // const getClaimStatsLEIA = () => fetchClaimStats("LEIA", "LEIA");
  // const getClaimStatsOlympus = () => fetchClaimStats("OLYMPUS", "OLYMPUS");
  // const getClaimStatsNFA = () => fetchClaimStats("NFA", "NFA");

  // ============= GENERIC CALCULATION FUNCTIONS =============

  // Token prices configuration
  const getTokenPrices = () => [
    { name: "ETH", price: usdPrice },
    { name: "USDT", price: 1 },
    { name: "DOP", price: dopPrice },
    { name: "WBTC", price: btcPrice },
    { name: "USDC", price: 1 },
    { name: "GEMS", price: gemsPrice },
    { name: "PEPE", price: pepePrice },
    { name: "UNI", price: uniPrice },
    { name: "LINK", price: linkPrice },
    { name: "TOMI", price: tomiPrice },
  ];

  // Generic calculation function for total purchase
  const calculateTotalPurchase = (projectId) => {
    const stats = projectStats[projectId];
    if (!stats?.purchasedAndEarnings?.length) return 0;

    const tokens = getTokenPrices();

    return stats.purchasedAndEarnings
      .reduce((total, purchase) => {
        const token = tokens.find(
          (t) => t.name === purchase?._id?.tokenSelected
        );
        return token ? ((total + token.price * purchase.totalPurchase) || 0) : total;
      }, 0)
      .toFixed(4);
  };

  // Generic calculation function for earnings
  const calculateMyEarnings = (projectId) => {
    const stats = projectStats[projectId];
    if (!stats?.purchasedAndEarnings?.length) return 0;

    const tokens = getTokenPrices();

    return stats.purchasedAndEarnings
      .reduce((total, purchase) => {
        const token = tokens.find(
          (t) => t.name === purchase?._id?.tokenSelected
        );
        return token
          ? ((total + token.price * purchase.totalLeaderEarnings) || 0)
          : (total || 0);
      }, 0)
      .toFixed(4);
  };

  // Backward compatible specific calculation functions
  const calculateTotalPurchaseChainers = () => calculateTotalPurchase("CHAINERS");
  const calculateMyEarningsChainers = () => calculateMyEarnings("CHAINERS");
  const calculateTotalPurchaseScrex = () => calculateTotalPurchase("SCREX");
  const calculateMyEarningsScrex = () => calculateMyEarnings("SCREX");
  const calculateTotalPurchaseLuckify = () => calculateTotalPurchase("LUCKIFY");
  const calculateMyEarningsLuckify = () => calculateMyEarnings("LUCKIFY");
  const calculateTotalPurchaseMatchain = () => calculateTotalPurchase("MATCHAIN");
  const calculateMyEarningsMatchain = () => calculateMyEarnings("MATCHAIN");
  const calculateTotalPurchaseRain = () => calculateTotalPurchase("RAIN");
  const calculateMyEarningsRain = () => calculateMyEarnings("RAIN");
  const calculateTotalPurchaseAstroNova = () => calculateTotalPurchase("ASTRANOVA");
  const calculateMyEarningsAstroNova = () => calculateMyEarnings("ASTRANOVA");
  const calculateTotalPurchaseNFA = () => calculateTotalPurchase("NFA");
  const calculateMyEarningsNFA = () => calculateMyEarnings("NFA");
  const calculateTotalPurchaseLEIA = () => calculateTotalPurchase("LEIA");
  const calculateMyEarningsLEIA = () => calculateMyEarnings("LEIA");
  const calculateTotalPurchaseOlympus = () => calculateTotalPurchase("OLYMPUS");
  const calculateMyEarningsOlympus = () => calculateMyEarnings("OLYMPUS");
  const calculateTotalPurchaseINCENTIV = () => calculateTotalPurchase("INCENTIV");
  const calculateMyEarningsINCENTIV = () => calculateMyEarnings("INCENTIV");
  const calculateTotalPurchaseGEMS = () => calculateTotalPurchase("GEMS");
  const calculateMyEarningsGEMS = () => calculateMyEarnings("GEMS");
  const calculateTotalPurchaseDOP = () => calculateTotalPurchase("DOP");
  const calculateMyEarningsDOP = () => calculateMyEarnings("DOP");
  const calculateTotalPurchaseMiners = () => calculateTotalPurchase("NODEMINER");
  const calculateMyEarningsMiners = () => calculateMyEarnings("NODEMINER");

  // Overall calculations (for all projects combined)
  const calculateTotalPurchasesOverall = () => {
    if (!purchasesAndEarnings?.length) return 0;
    const tokens = getTokenPrices();
    return purchasesAndEarnings
      .reduce((total, purchase) => {
        const token = tokens.find((t) => t.name === purchase?._id?.tokenSelected);
        return token ? total + token.price * purchase.totalPurchase : total;
      }, 0)
      .toFixed(4);
  };

  const calculateMyEarningsOverall = () => {
    if (!purchasesAndEarnings?.length) return 0;
    const tokens = getTokenPrices();
    return purchasesAndEarnings
      .reduce((total, purchase) => {
        const token = tokens.find((t) => t.name === purchase?._id?.tokenSelected);
        return token ? total + token.price * purchase.totalLeaderEarnings : total;
      }, 0)
      .toFixed(4);
  };

  // ============= PROJECT DATA ARRAY =============

  const projectData = projectConfigurations.map(config => ({
    id: config.id,
    name: config.name,
    shortName: config.shortName,
    imageSrc: config.imageSrc,
    stats: projectStats[config.id],
    refLink: config.refLink,
    enabled: config.enabled,
    calculateTotalPurchase: () => calculateTotalPurchase(config.id),
    calculateMyEarnings: () => calculateMyEarnings(config.id),
  }));

  // ============= USE EFFECT =============

  useEffect(() => {
    if (tok && tok !== "" && tok !== undefined) {
      // setLoader(true);

      ReputationPoints();

      // Fetch claim stats for all projects
      claimStatsConfigurations.forEach(config => {
        fetchClaimStats(config.privateSale, config.id);
      });

      // Fetch project card data for all projects
      projectConfigurations.forEach(config => {
        fetchProjectCardData(config.privateSale, config.id);
      });
    } else {
      history.push("/login");
    }
  }, []);
  return (
    <>
      {loader && <Loader />}
      <AddLeaderModal
        addLeaderModal={addLeaderModal}
        setAddLeaderModal={setAddLeaderModal}
        setAddLeadBool={setAddLeadBool}
        addLeaderBool={addLeaderBool}
      />
      <Header />
      <section className="maindashboard maindashboard-newstyle">
        <div className="theme-container">
          <div className="twice-new-style">
            <div className="left-side-content">
              <div className="upperdashboardmain">
                <h4 className="dashboardmainhead">WELCOME BACK, {user?.name}</h4>

                <div className="custom-tab-bar">
                  <a
                    className={alllset == "1" ? "active" : "noactive"}
                    onClick={() => {
                      setalllset("1");
                      GetDashboardDataMyUsers1("1");
                      // setDataTime("1");
                    }}
                  >
                    1D
                  </a>
                  <a
                    className={alllset == "seven" ? "active" : "noactive"}
                    onClick={() => {
                      setalllset("seven");
                      GetDashboardDataMyUsers1("seven");
                      // setDataTime("seven");
                    }}
                  >
                    7D
                  </a>
                  <a
                    className={alllset == "month" ? "active" : "noactive"}
                    onClick={() => {
                      setalllset("month");
                      GetDashboardDataMyUsers1("month");
                      // setDataTime("month");
                    }}
                  >
                    1M
                  </a>
                  <a
                    className={alllset == "year" ? "active" : "noactive"}
                    onClick={() => {
                      setalllset("year");
                      GetDashboardDataMyUsers1("year");
                      // setDataTime("year");
                    }}
                  >
                    1Y
                  </a>
                  <a
                    className={alllset == "all" ? "active" : "noactive"}
                    onClick={() => {
                      setalllset("all");
                      GetMyData();
                      // setDataTime("");
                    }}
                  >
                    All
                  </a>
                  <a onClick={() => setShowCalendar(!showcalendar)}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                    >
                      <path
                        d="M17.0833 3.56V2C17.0833 1.59 16.7433 1.25 16.3333 1.25C15.9233 1.25 15.5833 1.59 15.5833 2V3.5H9.08327V2C9.08327 1.59 8.74327 1.25 8.33327 1.25C7.92327 1.25 7.58327 1.59 7.58327 2V3.56C4.88327 3.81 3.57327 5.42 3.37327 7.81C3.35327 8.1 3.59327 8.34 3.87327 8.34H20.7933C21.0833 8.34 21.3233 8.09 21.2933 7.81C21.0933 5.42 19.7833 3.81 17.0833 3.56Z"
                        fill="#8C8C8C"
                      />
                      <path
                        d="M20.3333 9.83984H4.33328C3.78328 9.83984 3.33328 10.2898 3.33328 10.8398V16.9998C3.33328 19.9998 4.83328 21.9998 8.33328 21.9998H16.3333C19.8333 21.9998 21.3333 19.9998 21.3333 16.9998V10.8398C21.3333 10.2898 20.8833 9.83984 20.3333 9.83984ZM9.54328 18.2098C9.49328 18.2498 9.44328 18.2998 9.39328 18.3298C9.33328 18.3698 9.27328 18.3998 9.21328 18.4198C9.15328 18.4498 9.09328 18.4698 9.03328 18.4798C8.96328 18.4898 8.90328 18.4998 8.83328 18.4998C8.70328 18.4998 8.57328 18.4698 8.45328 18.4198C8.32328 18.3698 8.22328 18.2998 8.12328 18.2098C7.94328 18.0198 7.83328 17.7598 7.83328 17.4998C7.83328 17.2398 7.94328 16.9798 8.12328 16.7898C8.22328 16.6998 8.32328 16.6298 8.45328 16.5798C8.63328 16.4998 8.83328 16.4798 9.03328 16.5198C9.09328 16.5298 9.15328 16.5498 9.21328 16.5798C9.27328 16.5998 9.33328 16.6298 9.39328 16.6698C9.44328 16.7098 9.49328 16.7498 9.54328 16.7898C9.72328 16.9798 9.83328 17.2398 9.83328 17.4998C9.83328 17.7598 9.72328 18.0198 9.54328 18.2098ZM9.54328 14.7098C9.35328 14.8898 9.09328 14.9998 8.83328 14.9998C8.57328 14.9998 8.31328 14.8898 8.12328 14.7098C7.94328 14.5198 7.83328 14.2598 7.83328 13.9998C7.83328 13.7398 7.94328 13.4798 8.12328 13.2898C8.40328 13.0098 8.84328 12.9198 9.21328 13.0798C9.34328 13.1298 9.45328 13.1998 9.54328 13.2898C9.72328 13.4798 9.83328 13.7398 9.83328 13.9998C9.83328 14.2598 9.72328 14.5198 9.54328 14.7098ZM13.0433 18.2098C12.8533 18.3898 12.5933 18.4998 12.3333 18.4998C12.0733 18.4998 11.8133 18.3898 11.6233 18.2098C11.4433 18.0198 11.3333 17.7598 11.3333 17.4998C11.3333 17.2398 11.4433 16.9798 11.6233 16.7898C11.9933 16.4198 12.6733 16.4198 13.0433 16.7898C13.2233 16.9798 13.3333 17.2398 13.3333 17.4998C13.3333 17.7598 13.2233 18.0198 13.0433 18.2098ZM13.0433 14.7098C12.9933 14.7498 12.9433 14.7898 12.8933 14.8298C12.8333 14.8698 12.7733 14.8998 12.7133 14.9198C12.6533 14.9498 12.5933 14.9698 12.5333 14.9798C12.4633 14.9898 12.4033 14.9998 12.3333 14.9998C12.0733 14.9998 11.8133 14.8898 11.6233 14.7098C11.4433 14.5198 11.3333 14.2598 11.3333 13.9998C11.3333 13.7398 11.4433 13.4798 11.6233 13.2898C11.7133 13.1998 11.8233 13.1298 11.9533 13.0798C12.3233 12.9198 12.7633 13.0098 13.0433 13.2898C13.2233 13.4798 13.3333 13.7398 13.3333 13.9998C13.3333 14.2598 13.2233 14.5198 13.0433 14.7098ZM16.5433 18.2098C16.3533 18.3898 16.0933 18.4998 15.8333 18.4998C15.5733 18.4998 15.3133 18.3898 15.1233 18.2098C14.9433 18.0198 14.8333 17.7598 14.8333 17.4998C14.8333 17.2398 14.9433 16.9798 15.1233 16.7898C15.4933 16.4198 16.1733 16.4198 16.5433 16.7898C16.7233 16.9798 16.8333 17.2398 16.8333 17.4998C16.8333 17.7598 16.7233 18.0198 16.5433 18.2098ZM16.5433 14.7098C16.4933 14.7498 16.4433 14.7898 16.3933 14.8298C16.3333 14.8698 16.2733 14.8998 16.2133 14.9198C16.1533 14.9498 16.0933 14.9698 16.0333 14.9798C15.9633 14.9898 15.8933 14.9998 15.8333 14.9998C15.5733 14.9998 15.3133 14.8898 15.1233 14.7098C14.9433 14.5198 14.8333 14.2598 14.8333 13.9998C14.8333 13.7398 14.9433 13.4798 15.1233 13.2898C15.2233 13.1998 15.3233 13.1298 15.4533 13.0798C15.6333 12.9998 15.8333 12.9798 16.0333 13.0198C16.0933 13.0298 16.1533 13.0498 16.2133 13.0798C16.2733 13.0998 16.3333 13.1298 16.3933 13.1698C16.4433 13.2098 16.4933 13.2498 16.5433 13.2898C16.7233 13.4798 16.8333 13.7398 16.8333 13.9998C16.8333 14.2598 16.7233 14.5198 16.5433 14.7098Z"
                        fill="#8C8C8C"
                      />
                    </svg>
                  </a>
                  {/* {showcalendar && ( */}
                  {showcalendar && (
                    <div className="cal set-custom-calendar-div">
                      <DateRange
                        editableDateInputs={true}
                        onChange={(item) => {
                          GetDashboardDataMyUsers([item.selection]);
                        }}
                        moveRangeOnFirstSelection={false}
                        ranges={state}
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className="dashboardboxesmain">
                <div className="innerdashboardbox">
                  <div className="innerdashboardboxupper">
                    <img
                      src="\assets\dashboardassets\cardone.svg"
                      alt="dashboardboximg"
                      className="dashboardboximg"
                    />
                    <div className="dashboardboxtexts">
                      <p className="dashboardparatopbox">Total Purchases</p>

                      <h6 className="dashboardheadbox">
                        {usdPrice &&
                          purchasesAndEarnings?.length > 0
                          ? "~$" +
                          // parseInt(
                            calculateTotalPurchasesOverall()
                          // ).toLocaleString("en-US")
                          : 0}{" "}
                        <span className={pmc > 0 ? "greentext" : "redtext"}>
                          {pmc ? pmc.toFixed(1) + "% " : ""}
                        </span>
                      </h6>
                    </div>
                  </div>
                  <div className="valuemaindiv">
                    <Dropdown>
                      <Dropdown.Toggle id="dropdown-basic">
                        <img
                          src="\assets\dashboardassets\Caret_Down_MD.svg"
                          alt="arrowimg"
                          className="arrowimg"
                        />
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <div className="teamsdrops">
                          {tokens.map((token) => (
                            <div key={token} className="innerteamdrop">
                              <p className="teamdroppara">{token}</p>
                              <h6 className="teamdrophead">
                                {(
                                  purchasesAndEarnings?.find(
                                    (item) => item?._id?.tokenSelected === token
                                  )?.totalPurchase || 0
                                ).toFixed(5)}
                              </h6>
                            </div>
                          ))}
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>

                <div className="innerdashboardbox">
                  <div className="innerdashboardboxupper">
                    <img
                      src="\assets\dashboardassets\cardtwo.svg"
                      alt="dashboardboximg"
                      className="dashboardboximg"
                    />
                    <div className="dashboardboxtexts">
                      <p className="dashboardparatopbox">No. of Purchases</p>

                      <h6 className="dashboardheadbox">
                        {tokenNftStats?.totalPurchases || 0}
                        <span className={pc > 0 ? "greentext" : "redtext"}>
                          {pc ? pc.toFixed(1) + "% " : ""}
                        </span>
                      </h6>
                    </div>
                  </div>
                </div>

                <div className="innerdashboardbox">
                  <div className="innerdashboardboxupper">
                    <img
                      src="\assets\dashboardassets\cardthree.svg"
                      alt="dashboardboximg"
                      className="dashboardboximg"
                    />
                    <div className="dashboardboxtexts">
                      <p className="dashboardparatopbox">My Earning</p>
                      {usdPrice &&
                        purchasesAndEarnings?.length > 0 ? (
                        <h6 className="dashboardheadbox">
                          {purchasesAndEarnings?.length > 0
                            ? "~$" +
                            // parseInt(
                              calculateMyEarningsOverall()
                            // ).toLocaleString("en-US")
                            : 0}{" "}
                          <span className={lec > 0 ? "greentext" : "redtext"}>
                            {lec ? lec.toFixed(1) + "% " : ""}
                          </span>
                        </h6>
                      ) : (
                        <h6>~$0.00 USD</h6>
                      )}
                    </div>
                  </div>

                  <div className="valuemaindiv">
                    <Dropdown>
                      <Dropdown.Toggle id="dropdown-basic">
                        <img
                          src="\assets\dashboardassets\Caret_Down_MD.svg"
                          alt="arrowimg"
                          className="arrowimg"
                        />
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <div className="teamsdrops">
                          {tokens.map((token) => (
                            <div key={token} className="innerteamdrop">
                              <p className="teamdroppara">{token}</p>
                              <h6 className="teamdrophead">
                                {(
                                  purchasesAndEarnings?.find(
                                    (item) => item?._id?.tokenSelected === token
                                  )?.totalLeaderEarnings || 0
                                ).toFixed(5)}
                              </h6>
                            </div>
                          ))}
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
                <div className="innerdashboardbox">
                  <div className="innerdashboardboxupper">
                    <img
                      src="\assets\dashboardassets\cardfour.svg"
                      alt="dashboardboximg"
                      className="dashboardboximg"
                    />
                    <div className="dashboardboxtexts">
                      <p className="dashboardparatopbox">My Team</p>

                      {user?.role == "mini_agent" ? (
                        <h6 className="dashboardheadbox">
                          0{/* <span className={"redtext"}>0</span> */}
                        </h6>
                      ) : (
                        <h6 className="dashboardheadbox">
                          {(tokenNftStats?.leaders || 0) +
                            (tokenNftStats?.gods || 0) +
                            (tokenNftStats?.megas || 0) +
                            (tokenNftStats?.miniLeaders || 0) +
                            (tokenNftStats?.supers || 0)}
                          <span className={lc > 0 ? "greentext" : "redtext"}>
                            {lc ? lc.toFixed(1) + "% " : ""}
                          </span>
                        </h6>
                      )}
                    </div>
                  </div>
                  <div className="valuemaindiv">
                    {user?.role !== "mini_agent" && (
                      <Dropdown>
                        <Dropdown.Toggle id="dropdown-basic">
                          <img
                            src="\assets\dashboardassets\Caret_Down_MD.svg"
                            alt="arrowimg"
                            className="arrowimg"
                          />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          {user?.role === "god_agent" && (
                            <div className="teamsdrops">
                              <div className="innerteamdrop">
                                <p className="teamdroppara">Mega</p>
                                <h6 className="teamdrophead">
                                  {tokenNftStats?.megas}
                                </h6>
                              </div>
                              <div className="innerteamdrop">
                                <p className="teamdroppara">Super</p>
                                <h6 className="teamdrophead">
                                  {" "}
                                  {tokenNftStats?.supers}
                                </h6>
                              </div>
                              <div className="innerteamdrop">
                                <p className="teamdroppara">Leader</p>
                                <h6 className="teamdrophead">
                                  {tokenNftStats?.leaders}
                                </h6>
                              </div>
                              <div className="innerteamdrop">
                                <p className="teamdroppara">Ambassador</p>
                                <h6 className="teamdrophead">
                                  {tokenNftStats?.miniLeaders}
                                </h6>
                              </div>
                            </div>
                          )}
                          {user?.role === "mega_agent" && (
                            <div className="teamsdrops">
                              <div className="innerteamdrop">
                                <p className="teamdroppara">Super</p>
                                <h6 className="teamdrophead">
                                  {" "}
                                  {tokenNftStats?.supers}
                                </h6>
                              </div>
                              <div className="innerteamdrop">
                                <p className="teamdroppara">Leader</p>
                                <h6 className="teamdrophead">
                                  {tokenNftStats?.leaders}
                                </h6>
                              </div>
                              <div className="innerteamdrop">
                                <p className="teamdroppara">Ambassador</p>
                                <h6 className="teamdrophead">
                                  {tokenNftStats?.miniLeaders}
                                </h6>
                              </div>
                            </div>
                          )}
                          {user?.role === "super_agent" && (
                            <div className="teamsdrops">
                              <div className="innerteamdrop">
                                <p className="teamdroppara">Leader</p>
                                <h6 className="teamdrophead">
                                  {tokenNftStats?.leaders}
                                </h6>
                              </div>
                              <div className="innerteamdrop">
                                <p className="teamdroppara">Ambassador</p>
                                <h6 className="teamdrophead">
                                  {tokenNftStats?.miniLeaders}
                                </h6>
                              </div>
                            </div>
                          )}
                          {user?.role === "agent" && (
                            <div className="teamsdrops">
                              <div className="innerteamdrop">
                                <p className="teamdroppara">Ambassador</p>
                                <h6 className="teamdrophead">
                                  {tokenNftStats?.miniLeaders}
                                </h6>
                              </div>
                            </div>
                          )}
                        </Dropdown.Menu>
                      </Dropdown>
                    )}
                  </div>
                </div>

                <div className="innerdashboardbox">
                  <div className="innerdashboardboxupper">
                    <img
                      src="\assets\dashboardassets\cardfive.svg"
                      alt="dashboardboximg"
                      className="dashboardboximg"
                    />
                    <div className="dashboardboxtexts">
                      <p className="dashboardparatopbox">Avg. Team earning</p>

                      <h6 className="dashboardheadbox">
                        {purchasesAndEarnings?.length > 0
                          ? "~$" +
                          parseFloat(
                            (
                              (usdPrice *
                                (purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[0]?._id?.tokenSelected ==
                                  "ETH"
                                  ? purchasesAndEarnings[0]
                                    ?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[1]?._id
                                      ?.tokenSelected == "ETH"
                                    ? purchasesAndEarnings[1]
                                      ?.totalLeaderEarnings
                                    : purchasesAndEarnings &&
                                      purchasesAndEarnings?.length > 0 &&
                                      purchasesAndEarnings[2]?._id
                                        ?.tokenSelected == "ETH"
                                      ? purchasesAndEarnings[2]
                                        ?.totalLeaderEarnings
                                      : purchasesAndEarnings &&
                                        purchasesAndEarnings?.length > 0 &&
                                        purchasesAndEarnings[3]?._id
                                          ?.tokenSelected == "ETH"
                                        ? purchasesAndEarnings[3]
                                          ?.totalLeaderEarnings
                                        : purchasesAndEarnings &&
                                          purchasesAndEarnings?.length > 0 &&
                                          purchasesAndEarnings[4]?._id
                                            ?.tokenSelected == "ETH"
                                          ? purchasesAndEarnings[4]
                                            ?.totalLeaderEarnings
                                          : 0) +
                                (purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[0]?._id?.tokenSelected ==
                                  "USDT"
                                  ? purchasesAndEarnings[0]
                                    ?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[1]?._id
                                      ?.tokenSelected == "USDT"
                                    ? purchasesAndEarnings[1]
                                      ?.totalLeaderEarnings
                                    : purchasesAndEarnings &&
                                      purchasesAndEarnings?.length > 0 &&
                                      purchasesAndEarnings[2]?._id
                                        ?.tokenSelected == "USDT"
                                      ? purchasesAndEarnings[2]
                                        ?.totalLeaderEarnings
                                      : purchasesAndEarnings &&
                                        purchasesAndEarnings?.length > 0 &&
                                        purchasesAndEarnings[3]?._id
                                          ?.tokenSelected == "USDT"
                                        ? purchasesAndEarnings[3]
                                          ?.totalLeaderEarnings
                                        : purchasesAndEarnings &&
                                          purchasesAndEarnings?.length > 0 &&
                                          purchasesAndEarnings[4]?._id
                                            ?.tokenSelected == "USDT"
                                          ? purchasesAndEarnings[4]
                                            ?.totalLeaderEarnings
                                          : 0) +
                                tomiPrice *
                                (purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[0]?._id
                                    ?.tokenSelected == "TOMI"
                                  ? purchasesAndEarnings[0]
                                    ?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[1]?._id
                                      ?.tokenSelected == "TOMI"
                                    ? purchasesAndEarnings[1]
                                      ?.totalLeaderEarnings
                                    : purchasesAndEarnings &&
                                      purchasesAndEarnings?.length > 0 &&
                                      purchasesAndEarnings[2]?._id
                                        ?.tokenSelected == "TOMI"
                                      ? purchasesAndEarnings[2]
                                        ?.totalLeaderEarnings
                                      : purchasesAndEarnings &&
                                        purchasesAndEarnings?.length > 0 &&
                                        purchasesAndEarnings[3]?._id
                                          ?.tokenSelected == "TOMI"
                                        ? purchasesAndEarnings[3]
                                          ?.totalLeaderEarnings
                                        : purchasesAndEarnings &&
                                          purchasesAndEarnings?.length > 0 &&
                                          purchasesAndEarnings[4]?._id
                                            ?.tokenSelected == "TOMI"
                                          ? purchasesAndEarnings[4]
                                            ?.totalLeaderEarnings
                                          : 0) +
                                btcPrice *
                                (purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[0]?._id
                                    ?.tokenSelected == "WBTC"
                                  ? purchasesAndEarnings[0]
                                    ?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[1]?._id
                                      ?.tokenSelected == "WBTC"
                                    ? purchasesAndEarnings[1]
                                      ?.totalLeaderEarnings
                                    : purchasesAndEarnings &&
                                      purchasesAndEarnings?.length > 0 &&
                                      purchasesAndEarnings[2]?._id
                                        ?.tokenSelected == "WBTC"
                                      ? purchasesAndEarnings[2]
                                        ?.totalLeaderEarnings
                                      : purchasesAndEarnings &&
                                        purchasesAndEarnings?.length > 0 &&
                                        purchasesAndEarnings[3]?._id
                                          ?.tokenSelected == "WBTC"
                                        ? purchasesAndEarnings[3]
                                          ?.totalLeaderEarnings
                                        : purchasesAndEarnings &&
                                          purchasesAndEarnings?.length > 0 &&
                                          purchasesAndEarnings[4]?._id
                                            ?.tokenSelected == "WBTC"
                                          ? purchasesAndEarnings[4]
                                            ?.totalLeaderEarnings
                                          : 0) +
                                (purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[0]?._id?.tokenSelected ==
                                  "USDC"
                                  ? purchasesAndEarnings[0]
                                    ?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[1]?._id
                                      ?.tokenSelected == "USDC"
                                    ? purchasesAndEarnings[1]
                                      ?.totalLeaderEarnings
                                    : purchasesAndEarnings &&
                                      purchasesAndEarnings?.length > 0 &&
                                      purchasesAndEarnings[2]?._id
                                        ?.tokenSelected == "USDC"
                                      ? purchasesAndEarnings[2]
                                        ?.totalLeaderEarnings
                                      : purchasesAndEarnings &&
                                        purchasesAndEarnings?.length > 0 &&
                                        purchasesAndEarnings[3]?._id
                                          ?.tokenSelected == "USDC"
                                        ? purchasesAndEarnings[3]
                                          ?.totalLeaderEarnings
                                        : purchasesAndEarnings &&
                                          purchasesAndEarnings?.length > 0 &&
                                          purchasesAndEarnings[4]?._id
                                            ?.tokenSelected == "USDC"
                                          ? purchasesAndEarnings[4]
                                            ?.totalLeaderEarnings
                                          : 0) +
                                pepePrice *
                                (purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[0]?._id
                                    ?.tokenSelected == "PEPE"
                                  ? purchasesAndEarnings[0]
                                    ?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[1]?._id
                                      ?.tokenSelected == "PEPE"
                                    ? purchasesAndEarnings[1]
                                      ?.totalLeaderEarnings
                                    : purchasesAndEarnings &&
                                      purchasesAndEarnings?.length > 0 &&
                                      purchasesAndEarnings[2]?._id
                                        ?.tokenSelected == "PEPE"
                                      ? purchasesAndEarnings[2]
                                        ?.totalLeaderEarnings
                                      : purchasesAndEarnings &&
                                        purchasesAndEarnings?.length > 0 &&
                                        purchasesAndEarnings[3]?._id
                                          ?.tokenSelected == "PEPE"
                                        ? purchasesAndEarnings[3]
                                          ?.totalLeaderEarnings
                                        : purchasesAndEarnings &&
                                          purchasesAndEarnings?.length > 0 &&
                                          purchasesAndEarnings[4]?._id
                                            ?.tokenSelected == "PEPE"
                                          ? purchasesAndEarnings[4]
                                            ?.totalLeaderEarnings
                                          : 0) +
                                linkPrice *
                                (purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[0]?._id
                                    ?.tokenSelected == "LINK"
                                  ? purchasesAndEarnings[0]
                                    ?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[1]?._id
                                      ?.tokenSelected == "LINK"
                                    ? purchasesAndEarnings[1]
                                      ?.totalLeaderEarnings
                                    : purchasesAndEarnings &&
                                      purchasesAndEarnings?.length > 0 &&
                                      purchasesAndEarnings[2]?._id
                                        ?.tokenSelected == "LINK"
                                      ? purchasesAndEarnings[2]
                                        ?.totalLeaderEarnings
                                      : purchasesAndEarnings &&
                                        purchasesAndEarnings?.length > 0 &&
                                        purchasesAndEarnings[3]?._id
                                          ?.tokenSelected == "LINK"
                                        ? purchasesAndEarnings[3]
                                          ?.totalLeaderEarnings
                                        : purchasesAndEarnings &&
                                          purchasesAndEarnings?.length > 0 &&
                                          purchasesAndEarnings[4]?._id
                                            ?.tokenSelected == "LINK"
                                          ? purchasesAndEarnings[4]
                                            ?.totalLeaderEarnings
                                          : 0) +
                                uniPrice *
                                (purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[0]?._id
                                    ?.tokenSelected == "UNI"
                                  ? purchasesAndEarnings[0]
                                    ?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[1]?._id
                                      ?.tokenSelected == "UNI"
                                    ? purchasesAndEarnings[1]
                                      ?.totalLeaderEarnings
                                    : purchasesAndEarnings &&
                                      purchasesAndEarnings?.length > 0 &&
                                      purchasesAndEarnings[2]?._id
                                        ?.tokenSelected == "UNI"
                                      ? purchasesAndEarnings[2]
                                        ?.totalLeaderEarnings
                                      : purchasesAndEarnings &&
                                        purchasesAndEarnings?.length > 0 &&
                                        purchasesAndEarnings[3]?._id
                                          ?.tokenSelected == "UNI"
                                        ? purchasesAndEarnings[3]
                                          ?.totalLeaderEarnings
                                        : purchasesAndEarnings &&
                                          purchasesAndEarnings?.length > 0 &&
                                          purchasesAndEarnings[4]?._id
                                            ?.tokenSelected == "UNI"
                                          ? purchasesAndEarnings[4]
                                            ?.totalLeaderEarnings
                                          : 0) +
                                gemsPrice *
                                (purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[0]?._id
                                    ?.tokenSelected == "GEMS"
                                  ? purchasesAndEarnings[0]
                                    ?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[1]?._id
                                      ?.tokenSelected == "GEMS"
                                    ? purchasesAndEarnings[1]
                                      ?.totalLeaderEarnings
                                    : purchasesAndEarnings &&
                                      purchasesAndEarnings?.length > 0 &&
                                      purchasesAndEarnings[2]?._id
                                        ?.tokenSelected == "GEMS"
                                      ? purchasesAndEarnings[2]
                                        ?.totalLeaderEarnings
                                      : purchasesAndEarnings &&
                                        purchasesAndEarnings?.length > 0 &&
                                        purchasesAndEarnings[3]?._id
                                          ?.tokenSelected == "GEMS"
                                        ? purchasesAndEarnings[3]
                                          ?.totalLeaderEarnings
                                        : purchasesAndEarnings &&
                                          purchasesAndEarnings?.length > 0 &&
                                          purchasesAndEarnings[4]?._id
                                            ?.tokenSelected == "GEMS"
                                          ? purchasesAndEarnings[4]
                                            ?.totalLeaderEarnings
                                          : 0)) /
                              ((tokenNftStats?.leaders || 0) +
                                (tokenNftStats?.gods || 0) +
                                (tokenNftStats?.megas || 0) +
                                (tokenNftStats?.miniLeaders || 0) +
                                (tokenNftStats?.supers || 0) || 1)
                            )?.toFixed(4)
                          ).toLocaleString("en-US")
                          : 0}{" "}
                        <span className={lec > 0 ? "greentext" : "redtext"}>
                          {lec ? lec.toFixed(1) + "% " : ""}
                        </span>
                      </h6>
                    </div>
                  </div>
                </div>

                <div className="innerdashboardbox">
                  <div className="innerdashboardboxupper">
                    <img
                      src="\assets\dashboardassets\cardsix.svg"
                      alt="dashboardboximg"
                      className="dashboardboximg"
                    />
                    <div className="dashboardboxtexts">
                      <p className="dashboardparatopbox">Avg. Rank Earning</p>
                      <h6 className="dashboardheadbox">
                        $
                        {parseFloat(
                          (claimStats2?.avgEarningPerRole +
                            claimStats3?.avgEarningPerRole) || 0
                        )
                          ?.toFixed(2)
                          ?.toLocaleString()}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* {stakedAmount >= 18000 && moment().isBefore(stakeEndTime) ? (
             */}

            {subscriptionData?.length == 0 &&
              user?.isPremium == false &&
              stakedAmount < 18000 ? (
              <>
                <div className="staking-box set-custom-common-width latestsectionn">
                  <img
                    src="\assets\stake-bg.png"
                    alt="img"
                    className="img-fluid stake-bg"
                  />
                  <div className="upper-content">
                    <div className="text">
                      <p>Current Plan</p>
                      <h6>Basic</h6>
                    </div>
                  </div>
                  <span className="line"></span>
                  <div className="bottom-content">
                    <p>Start earning 100% of your rewards</p>
                    {/* <span className="planexpired">Plan expired on 6/07/24</span> */}
                    <Link to="/premium">Get Xen Premium</Link>

                    {/* <Link to="/premium">Upgrade Again</Link> */}
                  </div>
                </div>
              </>
            ) : stakingData.length > 0 &&
              stakingData[stakingData.length - 1]?.isClaimed == false ? (
              <>
                <div className="staking-box staking-box-premium set-custom-common-width">
                  <img
                    src="\assets\stake-bg-premium.png"
                    alt="img"
                    className="img-fluid stake-bg"
                  />
                  <div
                    className="upper-content"
                    style={{ border: "none", padding: "0" }}
                  >
                    <div className="text">
                      <p>Current Plan</p>
                      <h6 className="premiumhead">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="26"
                          height="26"
                          viewBox="0 0 26 26"
                          fill="none"
                        >
                          <path
                            d="M20.5832 3.25H5.4165L2.1665 9.75L12.9998 22.75L23.8332 9.75L20.5832 3.25ZM10.4215 8.66667L12.0465 5.41667H13.9532L15.5782 8.66667H10.4215ZM11.9165 10.8333V18.07L5.89317 10.8333H11.9165ZM14.0832 10.8333H20.1065L14.0832 18.07V10.8333ZM20.8648 8.66667H17.994L16.369 5.41667H19.2398L20.8648 8.66667ZM6.75984 5.41667H9.63067L8.00567 8.66667H5.13484L6.75984 5.41667Z"
                            fill="#E89735"
                          />
                        </svg>
                        Xen Premium
                      </h6>
                    </div>
                  </div>

                  <span className="line"></span>
                  <div className="bottom-content">
                    {/* <p className="newpremiumpara">
                  Start earning 100% of your rewards
                </p> */}
                    {/* <span className="currentspan">
                      <p className="spanpara">CURRENT PLAN</p>
                      {stakeEndTime > moment() ? (
                        <p>
                          expires on {moment(stakeEndTime)?.format("DD/MM/YY")}
                        </p>
                      ) : (
                        <p>
                          expires on{" "}
                          {moment(subscriptionEndTime)?.format("DD/MM/YY")}
                        </p>
                      )}
                    </span> */}
                    {/* <Link to="/premium" className="viewdetailink">
                      View Details {" >"}
                    </Link> */}
                    <Link to="/premium" className="viewdetailbtn">
                      View Details {" >"}
                    </Link>
                  </div>
                </div>
              </>
            ) : subscriptionData?.length > 0 &&
              moment() < subscriptionEndTime ? (
              <>
                <div className="staking-box staking-box-premium set-custom-common-width">
                  <img
                    src="\assets\stake-bg-premium.png"
                    alt="img"
                    className="img-fluid stake-bg"
                  />
                  <div
                    className="upper-content"
                    style={{ border: "none", padding: "0" }}
                  >
                    <div className="text">
                      <p>Current Plan</p>
                      <h6 className="premiumhead">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="26"
                          height="26"
                          viewBox="0 0 26 26"
                          fill="none"
                        >
                          <path
                            d="M20.5832 3.25H5.4165L2.1665 9.75L12.9998 22.75L23.8332 9.75L20.5832 3.25ZM10.4215 8.66667L12.0465 5.41667H13.9532L15.5782 8.66667H10.4215ZM11.9165 10.8333V18.07L5.89317 10.8333H11.9165ZM14.0832 10.8333H20.1065L14.0832 18.07V10.8333ZM20.8648 8.66667H17.994L16.369 5.41667H19.2398L20.8648 8.66667ZM6.75984 5.41667H9.63067L8.00567 8.66667H5.13484L6.75984 5.41667Z"
                            fill="#E89735"
                          />
                        </svg>
                        Xen Premium
                      </h6>
                    </div>
                  </div>

                  <span className="line"></span>
                  <div className="bottom-content">
                    {/* <p className="newpremiumpara">
                  Start earning 100% of your rewards
                </p> */}
                    <span className="currentspan">
                      <p className="spanpara">CURRENT PLAN</p>

                      <p>
                        expires on{" "}
                        {moment(subscriptionEndTime)?.format("DD/MM/YY")}
                      </p>
                    </span>
                    <Link to="/premium" className="viewdetailink">
                      View Details {" >"}
                    </Link>
                    {/* <Link to='/premium' className="viewdetailbtn">
                View Details { ' >'}
                </Link> */}
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="staking-box set-custom-common-width latestsectionn">
                  <img
                    src="\assets\stake-bg.png"
                    alt="img"
                    className="img-fluid stake-bg"
                  />
                  <div className="upper-content">
                    <div className="text">
                      <p>Current Plan</p>
                      <h6>Basic</h6>
                    </div>
                  </div>
                  <span className="line"></span>
                  <div className="bottom-content">
                    <span className="planexpired">
                      Plan expired on{" "}
                      {moment(subscriptionEndTime)?.format("DD/MM/YY")}
                    </span>
                    {/* <Link to="/premium">Get Xen Premium</Link> */}

                    <Link to="/premium">Upgrade Again</Link>
                  </div>
                </div>
              </>
            )}
          </div>

          <div className="ongoingprojectupper">
            <h4 className="ongoinghead">My Ongoing Projects</h4>
            {/* <button className="seeallbtn">
              See all
              <img
                src="\assets\dashboardassets\arrowimg.svg"
                alt="arrowimgbtn"
                className="arrowimgbtn"
              />
            </button> */}
          </div>
          <div className="ongoingcardmain">
            {/* {projectCardStatsRain?.purchasedAndEarnings?.length > 0 ? ( */}
            {projectData.map((project) => (
              <ProjectCard
                key={project.id} // Crucial: Provide a unique key for each item in the list
                project={project}
                usdPrice={usdPrice} // Pass necessary props down
                tomiPrice={tomiPrice}
                btcPrice={btcPrice}
              />
            ))}


          </div>

          {/* <div className="ongoingprojectupper mt-5">
            <h4 className="ongoinghead">Nodes and Miners</h4>
          </div>
          <div className="ongoingcardmain">
            <Link
              to="/dashboarddetail"
              onClick={() => {
                localStorage.setItem("project", "NODEMINER");
              }}
            >
              <div className="ongoingcard">
                <div className="ongoingcardupper">
                  <div className="ongoincardimg">
                    <img
                      src="/assets/miners.svg"
                      alt="ongoingcardinnerimg"
                      className="ongoingcardinnerimg"
                    />
                  </div>
                  <div className="ongoingcardtexts">
                    <h6 className="ongoingcardhead">Miners</h6>
                    <p className="ongoingcardpara">Miners</p>
                  </div>
                </div>
                <div className="ongoingcardlower">
                  <div className="ongoingcardlowertexts">
                    <p className="cardlowertextspara">Code</p>
                    <h6 className="cardlowertextshead">
                      {projectCardStatsMiners?.accessCode}
                    </h6>
                  </div>
                  <div className="ongoingcardlowertexts">
                    <p className="cardlowertextspara">No. of Purchases</p>
                    <h6 className="cardlowertextshead">
                      <h6 className="dashboardheadbox">
                        {projectCardStatsMiners?.totalPurchases || 0}
                      </h6>
                    </h6>
                  </div>
                  <div className="ongoingcardlowertexts">
                    <p className="cardlowertextspara">Total Purchases</p>
                    <h6 className="cardlowertextshead">
                      <h6 className="dashboardheadbox">
                        {usdPrice &&
                          tomiPrice &&
                          projectCardStatsMiners?.purchasedAndEarnings?.length > 0
                          ? "~$" +
                          parseFloat(
                            calculateTotalPurchaseMiners()
                          ).toLocaleString("en-US")
                          : 0}{" "}
                      </h6>
                    </h6>
                  </div>
                  <div className="ongoingcardlowertexts">
                    <p className="cardlowertextspara">My Earning</p>
                    <h6 className="cardlowertextshead">
                      {usdPrice &&
                        tomiPrice &&
                        btcPrice &&
                        projectCardStatsMiners?.purchasedAndEarnings?.length >
                        0 ? (
                        <h6 className="dashboardheadbox">
                          {projectCardStatsMiners?.purchasedAndEarnings
                            ?.length > 0
                            ? "~$" +
                            parseFloat(
                              calculateMyEarningsMiners()
                            ).toLocaleString("en-US")
                            : 0}{" "}
                        </h6>
                      ) : (
                        <h6>~$0.00 USD</h6>
                      )}
                    </h6>
                  </div>
                </div>
              </div>
            </Link>
          </div> */}
        </div>
      </section>
      <Footerline />

      <Modal
        className="stakingmodal premiumstake-modal"
        show={show}
        onHide={handleClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>REPUTATION POINTS</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="reputaion-modal-content">
            <p className="para">
              Reputation points are earned each time a sale is made using a
              premium leader's access code, or through the access code of any
              leader in the premium leader’s downline.
              <br />
              <br />
              Reputation points are used to add more leaders to your tree.
              <br />
              <br />
              Refer to the table below to see how many reputation points are
              required to add different leader roles to your tree:
            </p>
            <div className="inner-box">
              {user?.role == "god_agent" ? (
                <>
                  {" "}
                  <div className="text">
                    <p>ambassador</p>
                    <h6>1000</h6>
                  </div>
                  <div className="text">
                    <p>Leader</p>
                    <h6>50,000</h6>
                  </div>
                  <div className="text">
                    <p>super leader</p>
                    <h6>500,000</h6>
                  </div>
                  <div className="text">
                    <p>Mega leader</p>
                    <h6>1,000,000</h6>
                  </div>
                </>
              ) : user?.role == "mega_agent" ? (
                <>
                  <div className="text">
                    <p>ambassador</p>
                    <h6>1000</h6>
                  </div>
                  <div className="text">
                    <p>Leader</p>
                    <h6>50,000</h6>
                  </div>
                  <div className="text">
                    <p>super leader</p>
                    <h6>500,000</h6>
                  </div>
                </>
              ) : user?.role == "super_agent" ? (
                <>
                  {" "}
                  <div className="text">
                    <p>ambassador</p>
                    <h6>1000</h6>
                  </div>
                  <div className="text">
                    <p>Leader</p>
                    <h6>50,000</h6>
                  </div>
                </>
              ) : user?.role == "agent" ? (
                <>
                  {" "}
                  <div className="text">
                    <p>ambassador</p>
                    <h6>1000</h6>
                  </div>
                </>
              ) : null}
            </div>
            <a
              className="btn-leader"
              onClick={() => {
                handleClose();
                setAddLeaderModal(true);
              }}
            >
              ADD A LEADER
            </a>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="stakingmodal creditmodal"
        show={showcredits}
        onHide={handleClosecredits}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Credits packs</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="maincredits">
            <div className="creditrankmain">
              <div>
                <h6 className="credithead">Current Credits pack</h6>
                <div className="creditrank">
                  <h6 className={`creditrankpara ${getCreditPack()}`}>
                    {getCreditPack() == "noPack" ? (
                      "NONE"
                    ) : (
                      <>
                        <img
                          src={`/assets/${getCreditPack()}.svg`}
                          alt="creditrankimg"
                          className="creditrankimg"
                        />
                        {getCreditPack()}
                      </>
                    )}
                  </h6>
                </div>
              </div>
              {/* <div className="availablemain">
                <h6 className="availablehead">Available Credit</h6>
                {getCreditPack() == "noPack" ? (
                  <>
                    {" "}
                    <p className="availablepara">
                      <span className="greynumber">$0</span> / $0
                    </p>
                    <ProgressBar now={0} />
                  </>
                ) : (
                  <>
                    {" "}
                    <p className="availablepara">
                      <span className="greynumber">${}</span> / $20,000
                    </p>
                    <ProgressBar now={60} />
                  </>
                )}
              </div> */}
            </div>

            <div className="creditpackmain">
              <div className="packfirst">
                <div className="packhead">
                  <p className="packpara">PACKS</p>
                </div>
                <div className="tokenhead">
                  <p className="tokenpara">Xen Token required</p>
                </div>
                <div className="purchasehead">
                  <p className="purchasepara">
                    Purchase Amount <br /> Allowed in First Round $
                  </p>
                </div>
              </div>
              <div
                className={`rankmain ${getCreditPack() == "emerald" ? "activebg" : ""
                  }`}
              >
                <div className="ranktop">
                  <img
                    src="/assets/emerald.svg"
                    alt="ranktopimg"
                    className="ranktopimg"
                  />
                  <p className="ranktoppara">EMERALD</p>
                </div>
                <div className="rankmid">
                  <p className="rankmidnumber">30,000</p>
                </div>
                <div className="rankbottom">
                  <p className="rankbottompara">UP TO 20K</p>
                </div>
              </div>
              <div
                className={`rankmain ${getCreditPack() == "sapphire" ? "activebg" : ""
                  }`}
              >
                <div className="ranktop">
                  <img
                    src="/assets/sapphire.svg"
                    alt="ranktopimg"
                    className="ranktopimg"
                  />
                  <p className="ranktoppara">Sapphire</p>
                </div>
                <div className="rankmid">
                  <p className="rankmidnumber">75,000</p>
                </div>
                <div className="rankbottom">
                  <p className="rankbottompara">UP TO 40K</p>
                </div>
              </div>
              <div
                className={`rankmain ${getCreditPack() == "ruby" ? "activebg" : ""
                  }`}
              >
                <div className="ranktop">
                  <img
                    src="/assets/ruby.svg"
                    alt="ranktopimg"
                    className="ranktopimg"
                  />
                  <p className="ranktoppara">Ruby</p>
                </div>
                <div className="rankmid">
                  <p className="rankmidnumber">150,000</p>
                </div>
                <div className="rankbottom">
                  <p className="rankbottompara">UP TO 60K</p>
                </div>
              </div>
              <div
                className={`rankmain ${getCreditPack() == "diamond" ? "activebg" : ""
                  }`}
              >
                <div className="ranktop">
                  <img
                    src="/assets/diamond.svg"
                    alt="ranktopimg"
                    className="ranktopimg"
                  />
                  <p className="ranktoppara">Diamond</p>
                </div>
                <div className="rankmid">
                  <p className="rankmidnumber">450,000</p>
                </div>
                <div className="rankbottom">
                  <p className="rankbottompara">UP TO 200K</p>
                </div>
              </div>
              <div
                className={`rankmain ${getCreditPack() == "reddiamond" ? "activebg" : ""
                  }`}
              >
                <div className="ranktop" style={{ gap: "12px" }}>
                  <img
                    src="/assets/reddiamond.svg"
                    alt="ranktopimg"
                    className="ranktopimg"
                  />
                  <p className="ranktoppara">
                    Red <br /> Diamond
                  </p>
                </div>
                <div className="rankmid">
                  <p className="rankmidnumber">1,500,000</p>
                </div>
                <div className="rankbottom">
                  <p className="rankbottompara">Up to 5M</p>
                </div>
              </div>
            </div>
            <p className="requiremainpara">GEMS requirements</p>
            <div className="rquiremain">
              <div className="requireinner">
                <p className="requiregreypara">gems available in your wallet</p>
                <h6 className="requirenumber">{balance?.toLocaleString()}</h6>
              </div>
              <div className="requireinner">
                <p className="requiregreypara">your GEMS Staked</p>
                <h6 className="requirenumber">
                  {stakedAmount?.toLocaleString()} GEMS
                </h6>
              </div>
              <div className="requireinner">
                <p className="totalpara">Total GEMS</p>
                <h6 className="bluish">
                  {(balance + stakedAmount)?.toLocaleString()}
                </h6>
              </div>
            </div>
            <p className="morebottompara">GET MORE GEMS TO UPGRADE PACK</p>
            <button
              className="lastbtn"
              onClick={() =>
                window.open("https://www.bitget.com/spot/GEMSUSDT", "_blank")
              }
            >
              Buy Xen
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <ToastContainer
        position="bottom-end"   // bottom-right
        className="qrcode-toast"
      >
        <Toast
          show={showqr}
          onClose={() => setShowQr(false)}
          delay={5000}
          autohide
        >
          <Toast.Body>
            <div className="left-side">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                <g clip-path="url(#clip0_1850_1118)">
                  <circle cx="10.9994" cy="10.9994" r="10.9994" fill="#E2E9EC" />
                  <path d="M8.98219 16.6505L4.13867 11.8072L5.75303 10.1928L8.98219 13.4217L16.247 6.15668L17.8614 7.77104L8.98219 16.6505Z" fill="#329879" />
                </g>
                <defs>
                  <clipPath id="clip0_1850_1118">
                    <rect width="22" height="22" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              QR code downloaded to your device
            </div>
            <svg style={{ cursor: "pointer" }} onClick={() => setShowQr(false)} xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M5.25 12.75L12.7499 5.25006" stroke="#E2E9EC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M12.7499 12.7499L5.25 5.25" stroke="#E2E9EC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};

export default Dashboard;
